import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash';
import { ZoningCodeAttributesComponent } from './zoning-code-attributes.component';
import { CalibrationUsesLabelAttributesPopupComponent } from './attributes-popup/calibration-uses-label-attributes-popup/calibration-uses-label-attributes-popup.component';

@Component({
    standalone: false,
    selector: 'calibration-uses-label-attributes',
    templateUrl: './attributes.component.html',
    styleUrls: ['./attributes.component.scss']

})
export class CalibrationUsesLabelAttributesComponent extends ZoningCodeAttributesComponent implements OnInit {
    ngOnInit() {
        super.ngOnInit();
        this.popupComponent = CalibrationUsesLabelAttributesPopupComponent;
    }
}
